import axios from '@/libs/api.request'

export const getGlobalSetting = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/global'
  })
}

export const editGlobalSetting = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/global'
  })
}
